var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEmojis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,46C11.87,46,2,36.13,2,24S11.87,2,24,2s22,9.87,22,22-9.87,22-22,22Zm0-40C14.07,6,6,14.07,6,24s8.07,18,18,18,18-8.07,18-18S33.93,6,24,6Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.12,21.95c-.26,0-.52-.06-.76-.16s-.46-.24-.66-.42c-.38-.38-.58-.9-.58-1.42s.22-1.04,.58-1.42c.1-.08,.2-.18,.32-.24,.1-.08,.22-.14,.34-.2,.12-.04,.24-.08,.38-.1,.24-.06,.52-.06,.78,0,.12,.02,.24,.06,.36,.1,.12,.06,.24,.12,.36,.2,.1,.06,.2,.16,.3,.24,.36,.38,.58,.9,.58,1.42s-.2,1.04-.58,1.42c-.2,.18-.42,.32-.66,.42s-.5,.16-.76,.16Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.88,21.95c-.26,0-.52-.06-.76-.16s-.46-.24-.66-.42c-.38-.38-.58-.9-.58-1.42s.22-1.04,.58-1.42c.1-.08,.2-.18,.3-.24,.12-.08,.24-.14,.36-.2,.12-.04,.24-.08,.36-.1,.66-.14,1.36,.08,1.82,.54,.36,.38,.58,.9,.58,1.42s-.2,1.02-.58,1.42c-.2,.18-.42,.32-.66,.42-.24,.1-.5,.16-.76,.16Z",
    fill: outlineColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.74,34.71h-.11c-3.49-.04-6.68-1.8-8.53-4.71-.59-.93-.31-2.17,.62-2.76,.94-.59,2.17-.31,2.76,.62,1.14,1.79,3.03,2.83,5.19,2.86h.07c2.32,0,4.43-1.17,5.78-3.22,.61-.92,1.85-1.17,2.77-.56,.92,.61,1.17,1.85,.56,2.77-2.08,3.14-5.49,5.01-9.12,5.01Z",
    fill: outlineColor
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmojis);
export default __webpack_public_path__ + "static/media/ico-emojis.d6dc201f57398c90690c707bae6d1fe9.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;